export enum MarketingPlatforms {
  ALLPLATFORMS = 'All Platforms',
  FACEBOOK = 'facebook',
  TIKTOK = 'tik_tok',
  GOOGLE = 'google',
}
